import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fitsmith-academy/artifacts/zbh0gz3y_291E0B11-36FD-4420-BAF1-DDEC0FEFC105.png";

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="bg-[#080808] border-t border-white/5 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="FitSmith" className="h-9 w-9 object-contain" />
              <span className="text-white font-bold text-lg tracking-wider font-heading">FitSmith</span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed">Premium fitnessproducten voor iedereen die serieus wil werken aan resultaat.</p>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-widest">Navigatie</p>
            <div className="space-y-2.5">
              {[{ label: "Home", href: "#hero" }, { label: "Aanbod", href: "#aanbod" }, { label: "Over FitSmith", href: "#over" }, { label: "Reviews", href: "#reviews" }].map(link => (
                <button key={link.label} onClick={() => scrollTo(link.href)} className="block text-zinc-500 hover:text-[#C9A84C] text-sm transition-colors">{link.label}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-widest">Producten</p>
            <div className="space-y-2.5">
              {["Schema's", "De Cursus", "Personal Training"].map(p => (
                <button key={p} onClick={() => scrollTo("#aanbod")} className="block text-zinc-500 hover:text-[#C9A84C] text-sm transition-colors">{p}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-widest">Contact</p>
            <div className="space-y-2.5">
              <p className="text-zinc-500 text-sm">info@fitsmith.nl</p>
              <div className="flex gap-4 pt-2">
                <a href="https://www.instagram.com/fitsmith.s" target="_blank" rel="noopener noreferrer"
                  data-testid="instagram-link"
                  className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center text-zinc-500 hover:text-[#C9A84C] hover:border-[#C9A84C]/40 transition-all">
                  <Instagram size={14} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-zinc-600 text-xs">© 2026 FitSmith. Alle rechten voorbehouden.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/over-ons" data-testid="footer-over-ons-link"
              className="text-zinc-600 hover:text-[#C9A84C] text-xs transition-colors">
              Over Ons
            </Link>
            <Link to="/algemene-voorwaarden" data-testid="footer-av-link"
              className="text-zinc-600 hover:text-[#C9A84C] text-xs transition-colors">
              Algemene Voorwaarden
            </Link>
            <Link to="/privacybeleid" data-testid="footer-privacy-link"
              className="text-zinc-600 hover:text-[#C9A84C] text-xs transition-colors">
              Privacybeleid
            </Link>
            <Link to="/cookiebeleid" data-testid="footer-cookie-link"
              className="text-zinc-600 hover:text-[#C9A84C] text-xs transition-colors">
              Cookiebeleid
            </Link>
            <Link to="/restitutiebeleid" data-testid="footer-restitutiebeleid-link"
              className="text-zinc-600 hover:text-[#C9A84C] text-xs transition-colors">
              Restitutiebeleid
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
